import { JSX, Show } from 'solid-js';
import { Button, BtnClasses, getSvgIcon, TempSvgIcon } from '@tcweb/connect-ui';
import { UnreachableCaseError } from 'ts-essentials';

type ButtonSize = 'small' | 'medium' | 'large';

export const BasicButton = (props: {
  ['data-analytics-id']?: string;
  iconName: string;
  action(): void;
  tooltip?: string;
  text?: string;
  disabled?: boolean;
  pressed?: boolean;
  size?: ButtonSize;
}): JSX.Element => {
  const isSvgIcon = (): boolean => props.iconName.startsWith('svg-');
  const svgIcon = (): JSX.Element | null =>
    isSvgIcon()
      ? getSvgIcon(
          props.iconName as TempSvgIcon,
          `icon-${props.size ?? 'medium'}`
        )
      : null;

  const getSizeClasses = (): string => {
    switch (props.size) {
      case 'small':
        return '!w-8 !h-8 !min-w-8 !min-h-8';
      case 'medium':
      case undefined:
        return '!w-10 !h-10 !min-w-10 !min-h-10';
      case 'large':
        return '!w-12 !h-12 !min-w-12 !min-h-12';
      default:
        throw new UnreachableCaseError(props.size);
    }
  };

  const centerButtonContent = (): string => {
    return '[&>span]:flex [&>span]:flex-1 [&>span]:justify-center [&>span]:items-center';
  };

  return (
    <Show
      when={svgIcon()}
      fallback={
        <Button
          data-analytics-id={props['data-analytics-id']}
          icon={props.iconName}
          iconOnly={!props.text}
          content={props.text}
          disabled={props.disabled}
          state={props.pressed ? 'active' : 'default'}
          type={'hollow'}
          color={props.pressed ? BtnClasses.PRIMARY : BtnClasses.TERTIARY}
          size={props.size}
          onClick={props.action}
          title={props.tooltip ?? props.text}
          aria-label={props.tooltip ?? props.text}
          class={`${getSizeClasses()} !p-0`}
        />
      }
    >
      <Button
        data-analytics-id={props['data-analytics-id']}
        content={svgIcon()}
        disabled={props.disabled}
        state={props.pressed ? 'active' : 'default'}
        type={'hollow'}
        color={props.pressed ? BtnClasses.PRIMARY : BtnClasses.TERTIARY}
        size={props.size}
        onClick={props.action}
        title={props.tooltip ?? props.text}
        aria-label={props.tooltip ?? props.text}
        class={`${getSizeClasses()} !p-0 ${centerButtonContent()}`}
      />
    </Show>
  );
};
